import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { AccountInfo } from 'src/app/interfaces/account';
import { WebsiteDetail, WebsiteLink } from 'src/app/interfaces/website';
import { AccountInfoService } from 'src/app/services/account/account-info.service';
import { WebsiteDetailService } from 'src/app/services/website/website-detail.service';
import { WebsiteLinkService } from 'src/app/services/website/website-link.service';
import { WebsiteLinksService } from 'src/app/services/website/website-links.service';

@Component({
  selector: 'app-website-preview',
  templateUrl: './website-preview.component.html',
  styleUrls: ['./website-preview.component.scss'],
})
export class WebsitePreviewComponent  implements OnInit, OnDestroy {
  /**
  * Watch screen resize change
  */
  @HostListener('window:resize', ['$event']) onResize(event: any) {
    this.checkMobileMode();
  }
  
  /**
   * Watch screen orientation change
   */
  @HostListener('window:orientationchange', ['$event']) onOrientationChange(event: any) {
    this.checkMobileMode();
  } 
  
  @ViewChild('content', { read: ElementRef }) contentElement: ElementRef;
  
  showMobileBoolean: boolean;

  mobileMode: boolean;

  accountInfo: AccountInfo;

  websiteDetail: WebsiteDetail;
  websiteLink: WebsiteLink;

  ready: boolean;

  private websiteLinksSubscription: Subscription;

  constructor(
    private modalController: ModalController,
    private accountInfoService: AccountInfoService,
    private websiteDetailService: WebsiteDetailService,
    private websiteLinksService: WebsiteLinksService,
    private websiteLinkService: WebsiteLinkService,
  ) { }

  ngOnInit() {}

  ngOnDestroy(): void {
      this.ready = false;
  }

  ionViewWillEnter() {
    this.ready = true;
    if (!this.accountInfo) {
      this.accountInfo = this.accountInfoService.accountInfo;
    }

    if (!this.websiteDetail) {
      this.websiteDetail = this.websiteDetailService.getWebsiteDetail();
    }

    this.checkMobileMode();
    this.watchWebsiteLinks();
  }

  ionViewWillLeave() {
    this.ready = false;
    this.unwatchWebsiteLinks();
  }

  async watchWebsiteLinks() {
    if(!this.websiteLinksSubscription) {
      this.websiteLinksSubscription = this.websiteLinksService.observable.subscribe(() => {
        this.setupWebsiteLink();
      });
    }
  }

  async unwatchWebsiteLinks() {
    if (this.websiteLinksSubscription) {
      this.websiteLinksSubscription.unsubscribe();
      this.websiteLinksSubscription = null;
    }
  }

  async setupWebsiteLink() {
    this.websiteLink = await this.websiteLinkService.getWebsiteLink('', false, true, true, true);
  }

  getContentHeight(): number {
    return this.contentElement?.nativeElement?.offsetHeight ? this.contentElement.nativeElement.offsetHeight : window?.innerHeight ? window.innerHeight : 0;
  }

  back() {
    this.dismissModal();
  }

  async dismissModal() {
    if (this.modalController) {
      const modal = await this.modalController.getTop();
      if (modal) { this.modalController.dismiss(); }
    }
  }

  checkMobileMode() {
    if (this.contentElement?.nativeElement?.innerWidth > 767) {
      this.showMobileBoolean = true;
      this.mobileMode = false;
    } else if (window?.innerWidth > 767) {
      this.showMobileBoolean = true;
      this.mobileMode = false;
    } else {
      this.showMobileBoolean = false;
      this.mobileMode = false;
    }
  }

  toggleMobileMode() {
    this.mobileMode = !this.mobileMode;
  }

}
